exports.innerAction = [
    {
        _id: '002',
        name: '角色内置行为',
        action_list: [
            {
                name: '说话',
                id: 'role_001',
                template: 'talk'
            },
            {
                name: '标签',
                id: 'role_002',
                template: 'tag'
            }
        ]
    }
]